export function isSchemaAwaiting(validFrom: Date | string): boolean {
    const now = new Date();
    const validDate = new Date(validFrom);
    return validDate > now;
}